import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { TodayEventsService } from '../today-events/services/today-events.service';
import { Observable, Subject, forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-events-and-hearings',
    templateUrl: './events-and-hearings.component.html',
    styleUrls: ['./events-and-hearings.component.scss'],
    standalone: false
})
export class EventsAndHearingsComponent implements OnInit, OnDestroy {
  public filteredEvents: any[];
  categories: string[] = ['All', 'State House Events', 'Hearings', 'Legislative Sessions'];
  hearingRooms: string[] = ['A1', 'A2', 'B1', 'B2', 'Gardner Auditorium', 'House Chamber', 'House Gallery', '428', 'Senate Chamber', 'Senate Gallery']; //available hearing rooms to navigate to from the DirectionSettings.json
  public filterSelection: string;
  public showSpinner: boolean = true;
  faCircleNotch = faCircleNotch;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    protected http: HttpClient,
    protected router: Router,
    protected service: TodayEventsService,
    protected toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.filterSelection = 'All';
    this.loadData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData(): void {
    let requests: Observable<any>[];
    if (this.filterSelection === 'All') {
      requests = [
        this.service.getAdminEvents().pipe(take(1)),
        this.service.getHearings().pipe(take(1)),
        this.service.getSpecialEvents().pipe(take(1)),
        this.service.getSessions().pipe(take(1))
      ].sort((a: any, b: any) => {
        const startTimeA = new Date(a.startTime ? a.startTime : a.date).getTime();
        const startTimeB = new Date(b.startTime ? b.startTime : b.date).getTime();
        return startTimeA - startTimeB;
      });
    } else if (this.filterSelection === 'State House Events') {
      requests = [
        this.service.getAdminEvents().pipe(take(1)),
        this.service.getSpecialEvents().pipe(take(1))
      ];
    } else if (this.filterSelection === 'Hearings') {
      requests = [this.service.getHearings().pipe(take(1))];
    } else if (this.filterSelection === 'Legislative Sessions') {
      requests = [this.service.getSessions().pipe(take(1))];
    }

    forkJoin(requests).subscribe({
      next: (responses: any[]) => {
        this.filteredEvents = responses.flat().sort((a: any, b: any) => {
          const startTimeA = new Date(a.startTime ? a.startTime : a.date).getTime();
          const startTimeB = new Date(b.startTime ? b.startTime : b.date).getTime();
          return startTimeA - startTimeB;
        });;
        this.showSpinner = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.filteredEvents = [];
        this.showSpinner = false;
        this.cdr.detectChanges();
        console.error('Error loading events', error);
      }
    });
  }

  handleToggle(selection: string): void {
    this.filteredEvents = [];
    this.filterSelection = selection;
    this.showSpinner = true;
    this.loadData();
  }

  getDirection(location: string) {
    let cleanedLocation = location.trim().replace(/and Virtual/g, '').replace(/-/g, '').toLowerCase();
    cleanedLocation = cleanedLocation.replace(/-/g, '');
    cleanedLocation = cleanedLocation.replace(/&/g, '');

    const matchingRoom = this.hearingRooms.find(room => {
      const cleanedRoom = room.toLowerCase();
      if (cleanedRoom.includes(cleanedLocation)) {
        return true;
      }
      if (cleanedLocation.includes(cleanedRoom)) {
        return true;
      }
      return false;
    });

    if (matchingRoom) {
      this.router.navigate(['directions/', matchingRoom.trim(), '']);
    } else {
      this.toastr.warning('Direction is not yet available for this specific location'); //TBD MassLeg api WayfinderMothership need to be updated to add more directions
    }
  }
}
